import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet-async";

import HeroSection from "./HeroSection";
import OverviewSection from "./OverviewSection";

const ContentSection = lazy(() => import("./ContentSection"));
const AdvantageSection = lazy(() => import("./AdvantageSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));

const Loader = () => (
  <div className="h-[400px] flex items-center justify-center">
    <span className="text-gray-500">Loading...</span>
  </div>
);

const CustomDevelopment = () => {
  return (
    <>
      <Helmet>
        <title>
          Expert Software Consulting Services | Accelerate Digital Transformation
        </title>
        <meta
          name="description"
          content="Boost your business growth with expert software consulting. Our senior consultants provide strategic guidance, optimized systems, and flexible solutions."
        />
        <meta
          name="keywords"
          content="IT strategy consulting, technology consulting, software optimization"
        />
      </Helmet>

      <div className="bg-white font-poppins overflow-hidden">
        <HeroSection />
        <OverviewSection />

        <Suspense fallback={<Loader />}>
          <ContentSection />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <AdvantageSection />
        </Suspense>

        <Suspense fallback={<Loader />}>
          <BenefitSection />
        </Suspense>
      </div>
    </>
  );
};

export default CustomDevelopment;